"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState, type ReactNode } from "react";

import { getAppQueryClient } from "@/shared/api";
import { isDevelopmentNodeEnvironment } from "@/shared/environment";

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => getAppQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {isDevelopmentNodeEnvironment() ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
}
